@if (state(); as s) {
  <div class="read-only-banner" [class.grace]="s === 'grace'" role="status" data-cy="read-only-banner">
    <mat-icon>{{ s === 'grace' ? 'warning' : 'lock' }}</mat-icon>

    <div class="message">
      @if (s === 'grace') {
        <strong>Your last payment failed.</strong>
        Update your payment details by {{ organisation()!.readOnlyFrom | date: 'mediumDate' }}, or your organisation will become read-only:
        you will still be able to view and export your data, but not change, delete or print it.
      } @else {
        @if (isPaused()) {
          <strong>Your subscription is paused.</strong>
          Your organisation is read-only until it resumes: you can still view and export your data, but not change, delete or print it.
        } @else {
        <strong>Your organisation is read-only.</strong>
        @if (canResubscribe()) {
          Your subscription has ended. You can still view and export your data, but not change, delete or print it.
        } @else {
          You can still view and export your data, but not change, delete or print it. Contact barxui support to find out why.
        }
        }
      }
    </div>

    @if (canResubscribe() || isPaused()) {
      @if (isSubscriber()) {
        <a mat-flat-button routerLink="/settings/organisation" data-cy="read-only-banner-action">
          {{ s === 'grace' ? 'Update payment' : isPaused() ? 'Manage pause' : 'Resubscribe' }}
        </a>
      } @else {
        <span class="hint">Ask your organisation's subscriber to {{ s === 'grace' ? 'update the payment details' : isPaused() ? 'resume the subscription' : 'resubscribe' }}.</span>
      }
    }
  </div>
}
